export const TICKET_STATUS = {
  new: { label: "Neu", className: "bg-blue-100 text-blue-800 border border-blue-200", dot: "bg-blue-500" },
  in_review: { label: "In Prüfung", className: "bg-indigo-100 text-indigo-800 border border-indigo-200", dot: "bg-indigo-500" },
  in_progress: { label: "In Bearbeitung", className: "bg-amber-100 text-amber-800 border border-amber-200", dot: "bg-amber-500" },
  waiting_tenant: { label: "Wartet auf Mieter", className: "bg-purple-100 text-purple-800 border border-purple-200", dot: "bg-purple-500" },
  waiting_supplier: { label: "Wartet auf Dienstleister", className: "bg-fuchsia-100 text-fuchsia-800 border border-fuchsia-200", dot: "bg-fuchsia-500" },
  done: { label: "Erledigt", className: "bg-emerald-100 text-emerald-800 border border-emerald-200", dot: "bg-emerald-500" },
  closed: { label: "Geschlossen", className: "bg-slate-100 text-slate-600 border border-slate-200", dot: "bg-slate-400" },
};

export const TICKET_CATEGORIES = {
  heating: "Heizung",
  water: "Wasser / Sanitär",
  electricity: "Elektrik",
  gas: "Gas",
  lock_key: "Schlüssel / Schloss",
  damage: "Schaden",
  appliance: "Haushaltsgerät",
  noise: "Lärm",
  common_area: "Gemeinschaftsflächen",
  garden: "Garten / Außen",
  other: "Sonstiges",
};

export const TICKET_PRIORITY = {
  low: { label: "Niedrig", className: "bg-slate-100 text-slate-700" },
  medium: { label: "Mittel", className: "bg-blue-100 text-blue-800" },
  high: { label: "Hoch", className: "bg-amber-100 text-amber-800" },
  urgent: { label: "Dringend", className: "bg-rose-100 text-rose-800" },
};

export const BANK_MATCH_STATUS = {
  unmatched: { label: "Unzugeordnet", className: "bg-amber-100 text-amber-800 border border-amber-200" },
  auto: { label: "Auto-Zuordnung", className: "bg-emerald-100 text-emerald-800 border border-emerald-200" },
  manual: { label: "Manuell", className: "bg-blue-100 text-blue-800 border border-blue-200" },
  ignored: { label: "Ignoriert", className: "bg-slate-100 text-slate-600 border border-slate-200" },
};
